import { render } from "./ReleaseArticles.vue?vue&type=template&id=9032a960&scoped=true"
import script from "./ReleaseArticles.vue?vue&type=script&lang=js"
export * from "./ReleaseArticles.vue?vue&type=script&lang=js"

import "./ReleaseArticles.vue?vue&type=style&index=0&id=9032a960&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9032a960"]])

export default __exports__